"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LanguageSelector_1 = require("./LanguageSelector");
exports.LanguageSelector = LanguageSelector_1.default;
var reducer_1 = require("./redux/reducer");
exports.languageReducer = reducer_1.languageReducer;
var action_1 = require("./redux/action");
exports.changeLanguage = action_1.changeLanguage;
//# sourceMappingURL=index.js.map